import {
  EmergencyScenarioAccessPointTableFragment as EmergencyScenarioAccessPoint,
  EmergencyScenarioAccessPointTableFragmentDoc,
  getEmergencyScenarioAccessPointsDocument,
  getEmergencyScenarioAccessPointsTotalDocument,
} from '../../graphql/api/generated';
import { useMainApiTableData } from '../../hooks/useTableManager';
import { updatedAtColumn } from '../common/columns';

import * as columns from './columns';
import model from './model';

const commonTableConfig = {
  useTableData: useMainApiTableData({
    totalOperation: getEmergencyScenarioAccessPointsTotalDocument,
    listOperation: getEmergencyScenarioAccessPointsDocument,
  }),
  fragment: EmergencyScenarioAccessPointTableFragmentDoc, // @TODO: Not used, but required by config
};

export const EmergencyScenarioAccessPointsByAccessPointTable = model.createTable<
  EmergencyScenarioAccessPoint
>({
  ...commonTableConfig,
  title: 'Emergency Scenarios',
  fixedQueryFilters: accessPointId => ({ accessPointId }),
  columns: [
    columns.emergencyScenarioNameColumn,
    columns.emergencyScenarioStatusColumn,
    columns.emergencyPlanColumn,
    {
      ...updatedAtColumn,
      title: 'Date Added',
    },
  ],
  fetchPolicy: 'cache-first',
});
